import { Component, Input } from '@angular/core';
import { SortType } from '../constants-types/Enums';
import { UserUpdate } from '../core-data-model/User.model';
import { UsersTableData } from '../core-services/TableManager.dataservice';
import { UserDataService } from '../core-services/User.dataservice';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations/Translation.service';

@Component({
    selector: 'third-party-users-table',
    template: `
        <pi-table [table]="table" class="ok-table">
            <ng-template #header>
                <th [sortable-header]="SortType.Name">
                    {{ TR.key('label.common-terms.name') }}
                </th>
                <th [sortable-header]="SortType.Email">
                    {{ TR.key('label.email') }}
                </th>
                @if (hardcodeAccessColumn) {
                    <th>
                        <div class="columnHeader">
                            {{ TR.key('userManagement.sharing.permission') }}
                        </div>
                    </th>
                } @else {
                    <th [sortable-header]="SortType.Access">
                        {{ TR.key('text.common-terms.access') }}
                    </th>
                }
            </ng-template>
            <ng-template #dataRow let-item="item">
                <td>
                    {{ item.getFullName() }}
                </td>
                <td>
                    {{ item.email }}
                </td>
                @if (hardcodeAccessColumn) {
                    <td>
                        {{ TR.key('text.common-terms.edit') }}
                    </td>
                } @else {
                    <td>
                        <pi-toggle
                            [(ngModel)]="item.accessEnabled"
                            [ngClass]="{
                                accessToggle: !isToggleReadonly()
                            }"
                            (click)="captureUserToBeEnabled(item)"
                            [readOnly]="isToggleReadonly()"
                        ></pi-toggle>
                    </td>
                }
            </ng-template>
        </pi-table>
        @if (showModal) {
            <third-party-access-enable-modal
                (modalClosed)="cancelAction()"
                (performAction)="enableUserAccessAndCloseModal(userToBeEnabled)"
            >
            </third-party-access-enable-modal>
        }
    `,
    standalone: false
})
export class ThirdPartyUsersTableComponent {
    @Input()
    readOnly = false;

    @Input()
    hardcodeAccessColumn = false;

    @Input()
    table: UsersTableData;
    SortType = SortType;
    showModal = false;
    userToBeEnabled: UserUpdate;

    constructor(
        public TR: TranslationService,
        private userService: UserDataService,
        private userProfile: UserProfileSettingsService
    ) {}

    captureUserToBeEnabled(item: UserUpdate) {
        // Show Confirmation modal only while enabling Third Party Users
        if (!this.isToggleReadonly()) {
            if (item.accessEnabled) {
                this.showModal = true;
                this.userToBeEnabled = item;
            } else {
                this.toggleUserAccess(item);
            }
        }
    }

    isToggleReadonly() {
        return this.readOnly
            ? true
            : !(
                  this.userProfile.isUserSuperAdmin() ||
                  this.userProfile.isUserLoggedInDefaultCompany()
              );
    }

    async toggleUserAccess(item: UserUpdate) {
        if (!this.isToggleReadonly()) {
            try {
                await this.userService.updateUserAccess(
                    item.id,
                    true,
                    item.accessEnabled
                );
            } catch {
                item.accessEnabled = !item.accessEnabled;
            }
        }
    }

    // Handles the race condition where user attempts to enable access, disable access and try re-enabling quickly
    async enableUserAccessAndCloseModal(item: UserUpdate) {
        this.showModal = false;
        await this.toggleUserAccess(item);
    }

    cancelAction() {
        if (this.userToBeEnabled && this.userToBeEnabled.accessEnabled) {
            this.userToBeEnabled.accessEnabled = false;
        }
        this.showModal = false;
    }
}
